export default {
      id: "profile-usage",
      viewBox: "0 0 21.53 22.02",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#profile",
      toString: function () {
        return this.url;
      }
    }